<ng-container *ngIf="authUser$ | async; let user">
    <div fxLayout="column" class="question-container" *ngIf="materialResource && materialOccasion; else loading">
        <ng-container *ngIf="items$ | async; let items; else: loading">
            <ng-container *ngIf="materialItemOccasion$ | async; let materialItemOccasion; else: loading">
                <ng-container *ngIf="materialItem$ | async; let currentMaterialItem; else: loading">
                    <h1
                        class="material-title"
                        data-testid="player-material-title"
                        fxFlex="0 1 auto"
                        *ngIf="
                            !currentMaterialItem.metadata ||
                            !currentMaterialItem.metadata?.visibility ||
                            currentMaterialItem.metadata?.visibility?.headline
                        "
                    >
                        {{ currentMaterialItem.title }}
                    </h1>

                    <div
                        fxFlex="1 1 auto"
                        class="item-container"
                        [ngClass]="{
                            'mt-0':
                                !currentMaterialItem.metadata ||
                                !currentMaterialItem.metadata?.visibility ||
                                currentMaterialItem.metadata?.visibility?.headline
                        }"
                        fxLayout="column"
                        data-testid="player-material-play"
                    >
                        <div class="item" fxFlex="1 1 auto">
                            <div fxLayout="column" fxLayoutAlign="center center" class="card-container">
                                <mat-card
                                    [ngResizable]="true"
                                    [rzMinWidth]="400"
                                    (rzStart)="startingResizing = true"
                                    rzHandles="e"
                                    class="mat-main-card resize-container"
                                    fxFlex="1 0 auto"
                                    fxLayout="column"
                                    [ngStyle]="{ 'max-width': startingResizing ? 'unset' : '100%' }"
                                >
                                    <mat-icon fxHide fxShow.gt-sm class="resizable-icon">settings_ethernet</mat-icon>
                                    <mat-card-content class="content">
                                        <div class="mat-card-content-child" fxFlex="1 1 100%" fxLayout="column">
                                            <div
                                                *ngIf="materialResource.description"
                                                fxLayoutAlign="end center"
                                                class="form"
                                            >
                                                <button mat-icon-button (click)="showDesc()" matTooltip="Description">
                                                    <mat-icon>description</mat-icon>
                                                </button>
                                            </div>

                                            <div
                                                *ngIf="currentMaterialItem.item_type_value != 'item_container'"
                                                class="media_wrapper"
                                            >
                                                <app-player-media-view
                                                    class="media"
                                                    [resourceItemTypeValue]="currentMaterialItem.item_type_value"
                                                    [media_id]="currentMaterialItem.name"
                                                    [canDownlaodMedia]="currentMaterialItem.can_download"
                                                    [displayName]="false"
                                                    [autoplay]="true"
                                                    (downloading)="setCloseEnable(true)"
                                                    (played)="setCloseEnable($event)"
                                                    (mediaCompleted)="
                                                        onMediaCompleted($event, materialItemOccasion, items)
                                                    "
                                                    (nextBtnClickedInPDF)="nextBtnClickedInPDF = true"
                                                    (done)="onClosing(user)"
                                                    (playerReady)="onPlayerReady()"
                                                    (onMediaUpdated)="onMediaUpdated($event)"
                                                >
                                                </app-player-media-view>
                                            </div>
                                            <div
                                                *ngIf="currentMaterialItem.item_type_value == 'item_container'"
                                                class="media_wrapper"
                                            >
                                                <app-material-welcome-type-parent-shared
                                                    class="material-parent-container"
                                                    [parentItem]="currentMaterialItem"
                                                    (setCloseEnable)="setCloseEnable($event)"
                                                >
                                                </app-material-welcome-type-parent-shared>
                                            </div>

                                            <div *ngIf="materialResource.instructions" class="form">
                                                <!-- <span class="title" i18n="@@contentInformation">Content information</span> -->
                                                <div
                                                    class="tool_desc"
                                                    [innerHtml]="
                                                        materialResource.instructions | innerHtml : 'tool_desc'
                                                    "
                                                ></div>
                                            </div>

                                            <div
                                                [ngClass]="{ loadingNav: loadingNavigation | async }"
                                                class="next-btn-top"
                                                fxLayout="row"
                                                fxLayoutAlign="end center"
                                                fxLayoutGap="10px"
                                            >
                                                <ng-container *ngIf="materialWithOptions">
                                                    <ng-container *ngIf="currentMedia.mediaType == MediaType.PDF">
                                                        <ng-container
                                                            *ngIf="mediaView"
                                                            [ngTemplateOutlet]="pdfNav"
                                                        ></ng-container>
                                                        <button
                                                            (click)="openInNewTab()"
                                                            matTooltip="Open in a new tab"
                                                            i18n-matTooltip="@@openInAnewTab"
                                                            mat-icon-button
                                                            class="next-btn"
                                                            color="primary"
                                                        >
                                                            <mat-icon>launch</mat-icon>
                                                        </button>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="
                                                            currentMedia.mediaType == MediaType.VIDEO ||
                                                            currentMedia.mediaType == MediaType.AUDIO
                                                        "
                                                    >
                                                        <ng-container
                                                            *ngIf="mediaView && mediaView.player"
                                                            [ngTemplateOutlet]="playerControls"
                                                        ></ng-container>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="
                                                            currentMedia.mediaType == MediaType.URL ||
                                                            currentMedia.mediaType == MediaType.LINK
                                                        "
                                                    >
                                                        <button
                                                            (click)="openInNewTab()"
                                                            matTooltip="Open in a new tab"
                                                            i18n-matTooltip="@@openInAnewTab"
                                                            mat-icon-button
                                                            class="next-btn"
                                                            color="primary"
                                                        >
                                                            <mat-icon>launch</mat-icon>
                                                        </button>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="items.length > 1"
                                                    [ngTemplateOutlet]="materialItemsNav"
                                                    [ngTemplateOutletContext]="{
                                                        items: items,
                                                        materialItemOccasion: materialItemOccasion,
                                                        currentMaterialItem: currentMaterialItem
                                                    }"
                                                ></ng-container>

                                                <button
                                                    *ngIf="!actionBtn"
                                                    (click)="onClosing(user)"
                                                    mat-raised-button
                                                    class="next-btn"
                                                    color="primary"
                                                    [ngClass]="{ disabled: !closeEnabled }"
                                                    [class.secNext]="materialWithOptions"
                                                    i18n="@@close"
                                                    data-testid="player-material-close"
                                                >
                                                    Close
                                                </button>
                                                <ng-container *ngIf="actionBtn">
                                                    <ng-container [ngTemplateOutlet]="actionBtn"></ng-container>
                                                </ng-container>
                                                <app-kd-logo-loading
                                                    *ngIf="loadingNavigation | async"
                                                    class="loading-nav"
                                                    size="small"
                                                ></app-kd-logo-loading>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="no-items-container" *ngIf="!items?.length">
                    <h1 i18n>All items are hidden, please contact the administrator.</h1>
                    <button (click)="onExit()" mat-raised-button class="next-btn" color="primary" i18n="@@close">
                        Close
                    </button>
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-container>

<ng-template #loading>
    <div class="mt-2 mb-1" fxLayout="row" fxLayoutAlign="center center">
        <app-kd-logo-loading></app-kd-logo-loading>
    </div>
</ng-template>
<ng-template #pdfNav>
    <button
        mat-icon-button
        (click)="mediaView.firstPage()"
        [disabled]="mediaView.page === 1"
        type="button"
        matTooltip="First page"
        i18n-matTooltip="@@firstPage"
    >
        <mat-icon>first_page</mat-icon>
    </button>
    <button
        mat-icon-button
        (click)="mediaView.previousPage()"
        [disabled]="mediaView.page === 1"
        type="button"
        matTooltip="Previous"
        i18n-matTooltip="@@previous"
    >
        <mat-icon>navigate_before</mat-icon>
    </button>

    <span class="page-count">{{ mediaView.page }} / {{ mediaView.totalPages }}</span>

    <button
        mat-icon-button
        (click)="mediaView.nextPage()"
        [disabled]="mediaView.page === mediaView.totalPages"
        type="button"
        matTooltip="Next"
        i18n-matTooltip="@@next"
    >
        <mat-icon>navigate_next</mat-icon>
    </button>
    <button
        mat-icon-button
        (click)="mediaView.lastPage()"
        [disabled]="mediaView.page === mediaView.totalPages"
        type="button"
        matTooltip="Last page"
        i18n-matTooltip="@@lastPage"
    >
        <mat-icon>last_page</mat-icon>
    </button>
</ng-template>

<ng-template #playerControls>
    <button
        *ngIf="mediaView.player.isPlaying"
        (click)="mediaView.player.seekTime(10, false)"
        mat-icon-button
        class="next-btn mr-0"
        color="primary"
        matTooltip="Backward 10 seconds"
        i18n-matTooltip="@@backward"
    >
        <mat-icon>replay_10</mat-icon>
    </button>
    <button
        *ngIf="mediaView.player.isPlaying"
        (click)="mediaView.player.seekTime(10, true)"
        mat-icon-button
        class="next-btn"
        color="primary"
        matTooltip="Forward 10 seconds"
        i18n-matTooltip="@@forward10"
    >
        <mat-icon>forward_10</mat-icon>
    </button>
    <button
        *ngIf="mediaView.player.isPlaying"
        (click)="mediaView.player.pause()"
        mat-raised-button
        class="next-btn"
        color="primary"
    >
        <mat-icon>pause</mat-icon>
        <span i18n="@@pause">Pause</span>
    </button>
    <button
        *ngIf="!mediaView.player.isPlaying"
        (click)="mediaView.player.play()"
        mat-raised-button
        class="next-btn"
        color="primary"
    >
        <mat-icon>play_circle</mat-icon>
        <span i18n="@@play">Play</span>
    </button>
</ng-template>
<ng-template
    #materialItemsNav
    let-items="items"
    let-materialItemOccasion="materialItemOccasion"
    let-currentMaterialItem="currentMaterialItem"
>
    <ng-container *ngIf="items.length > 1">
        <button
            class="nav-btn"
            mat-icon-button
            (click)="goToIndex(0, materialItemOccasion, items)"
            [disabled]="currentIndex == 0"
            type="button"
            matTooltip="First item"
            i18n-matTooltip="@@firstItem"
        >
            <mat-icon>first_page</mat-icon>
        </button>
        <button
            class="nav-btn"
            mat-icon-button
            [disabled]="currentIndex === 0"
            (click)="goToIndex(currentIndex - 1, materialItemOccasion, items)"
            type="button"
            matTooltip="Previous"
            i18n-matTooltip="@@previous"
        >
            <mat-icon>navigate_before</mat-icon>
        </button>

        <span class="page-count">{{ currentIndex + 1 }} / {{ items.length }}</span>

        <button
            class="nav-btn"
            mat-icon-button
            [disabled]="currentIndex === items.length - 1"
            (click)="goToIndex(currentIndex + 1, materialItemOccasion, items)"
            type="button"
            matTooltip="Next"
            i18n-matTooltip="@@next"
        >
            <mat-icon>navigate_next</mat-icon>
        </button>
        <button
            class="nav-btn"
            mat-icon-button
            (click)="goToIndex(items.length - 1, materialItemOccasion, items)"
            [disabled]="currentIndex + 1 == items.length"
            type="button"
            matTooltip="Last item"
            i18n-matTooltip="@@lastItem"
        >
            <mat-icon>last_page</mat-icon>
        </button>
    </ng-container>
</ng-template>
